import { apiGet, apiPatch } from './client';

export interface OrgSettings {
  id: string;
  name: string;
  slug: string;
  plan: string;
  failure_mode: string;
  /** "none" (caller's principal_id is trusted) or "verified_token" (X-End-User-Token required and must match). */
  subject_verification: 'none' | 'verified_token';
  llm_provider: string;
  llm_api_key_configured: boolean;
  llm_fallback_credits_used: number;
  llm_fallback_credits_limit: number;
  llm_key_uses: number;
  llm_key_query_cap: number | null;
  llm_fallback_available: boolean;
}

export interface UpdateOrgSettingsBody {
  name?: string;
  failure_mode?: string;
  subject_verification?: 'none' | 'verified_token';
  llm_api_key?: string;
  llm_provider?: string;
  clear_llm_api_key?: boolean;
  llm_key_query_cap?: number | null;
}

export function getOrgSettings(): Promise<OrgSettings> {
  return apiGet<OrgSettings>('/organization/settings');
}

export function updateOrgSettings(body: UpdateOrgSettingsBody): Promise<OrgSettings> {
  return apiPatch<OrgSettings>('/organization/settings', body);
}
